import { AnalyticsEvents } from '@mondaygpt/analytics-events'
import { useAnalytics } from 'hooks'
import { useCallback } from 'react'
import { useAppDispatch, useAppSelector } from '../../core'
import { selectBusinessEntitlement } from '../slices'
import { openTopUpModal, type TopUpSource } from '../slices/revenue-cat.slice'

type CreditsExhaustedTopUpOptions = {
  modalSource: NonNullable<TopUpSource>
  /** Mixpanel `source` — defaults to `modalSource`; billing notice uses `billing_banner`. */
  analyticsSource?: string
}

export function useCreditsExhaustedTopUp({
  modalSource,
  analyticsSource,
}: CreditsExhaustedTopUpOptions) {
  const dispatch = useAppDispatch()
  const { track } = useAnalytics()
  const entitlement = useAppSelector(selectBusinessEntitlement)
  const tier = entitlement?.tier || 'Free'

  return useCallback(() => {
    track(AnalyticsEvents.Credits.CREDITS_EXHAUSTED_TOPUP_TAPPED, {
      tier,
      source: analyticsSource ?? modalSource,
    })
    dispatch(openTopUpModal({ source: modalSource }))
  }, [analyticsSource, dispatch, modalSource, tier, track])
}
